// Battle Cards CardContent.js - Fantasy Battle Characters
import { getCardByPosition } from './StaticCardMapping.js';

export const CARD_CONTENT = {
    "001": {
        characterName: "Twin War Chiefs",
        title: "Legendary Rivals",
        story: "Two mighty Native American war chiefs locked in an eternal contest of strength and honor. Their rivalry has become legend, with each warrior pushing the other to greater heights of prowess and skill.",
        background: "Born of rival tribes but bound by mutual respect, these champions represent the finest warrior traditions of their people, their conflict as much about proving worthiness as achieving victory.",
        abilities: ["Tomahawk Strike", "Warrior's Pride", "Tribal Fury"],
        element: "Earth",
        origin: "The Sacred Battlegrounds"
    },
    "002": {
        characterName: "Thunderhoof Champion",
        title: "Minotaur Gladiator",
        story: "A legendary minotaur warrior who dominates the ancient colosseum with raw power and primal fury. His thunderous charge and bone-crushing strength have made him the most feared champion in the sacred arena.",
        background: "Once a wild beast of the labyrinth, he was captured and trained as a gladiator. Through countless battles, he has earned both freedom and respect, choosing to remain in the arena where his legend continues to grow with each victory.",
        abilities: ["Thunderous Charge", "Primal Roar", "Bone Crusher"],
        element: "Earth",
        origin: "The Sacred Colosseum"
    },
    "003": {
        characterName: "Infernal Knight",
        title: "Hell's Champion",
        story: "A demonic knight whose armor is forged from the bones of fallen angels. His presence alone can melt steel and his sword burns with eternal hellfire.",
        background: "Fell from grace during the great rebellion, choosing power over righteousness, and was reforged in the flames of damnation.",
        abilities: ["Hellfire Blade", "Molten Armor", "Demonic Strength"],
        element: "Fire",
        origin: "Fallen Heaven"
    },
    "004": {
        characterName: "Blood Baron",
        title: "Crimson Tyrant",
        story: "A vampiric lord whose red armor is stained with the blood of countless victims. His pale skin and fanged grin strike terror into the hearts of mortals.",
        background: "An ancient nobleman who traded his soul for immortality, now rules over legions of the undead from his crimson castle.",
        abilities: ["Blood Drain", "Vampiric Flight", "Crimson Command"],
        element: "Death",
        origin: "The Crimson Castle"
    },
    "005": {
        characterName: "Forest Guardian",
        title: "Nature's Sentinel",
        story: "A mystical warrior blessed by the ancient trees, his green armor channels the life force of the eternal forest. Vines and leaves grow from his very being.",
        background: "Chosen by the World Tree to protect the sacred groves from those who would destroy nature's balance.",
        abilities: ["Thorn Whip", "Nature's Shield", "Root Bind"],
        element: "Nature",
        origin: "The Sacred Grove"
    },
    "006": {
        characterName: "Storm Caller",
        title: "Master of Lightning",
        story: "A blue-skinned elemental warrior who commands the power of storms. Lightning dances across his form as thunder follows in his wake.",
        background: "Born during the greatest tempest ever recorded, he embodies the raw fury and unpredictable nature of the storm itself.",
        abilities: ["Lightning Bolt", "Thunder Clap", "Storm Shield"],
        element: "Lightning",
        origin: "The Eternal Storm"
    },
    "007": {
        characterName: "Void Stalker",
        title: "Hunter of Shadows",
        story: "A dark assassin whose form seems to absorb light itself. His spider-like appearance and winged arms make him a perfect predator in the darkness.",
        background: "Emerged from the spaces between worlds where reality grows thin, hunting those who dare to pierce the veil of existence.",
        abilities: ["Shadow Strike", "Void Walk", "Web of Darkness"],
        element: "Shadow",
        origin: "The Void Between"
    },
    "008": {
        characterName: "Golden Goblin",
        title: "Goblin King",
        story: "An undead ruler whose golden armor gleams with the power of the sun. Though long dead, his will remains unbroken and his authority absolute.",
        background: "A pharaoh who refused to accept death, binding his soul to golden artifacts to rule his desert kingdom for eternity.",
        abilities: ["Solar Beam", "Golden Armor", "Royal Command"],
        element: "Light",
        origin: "The Eternal Desert"
    },
    "009": {
        characterName: "Arcane Destroyer",
        title: "Magic's Bane",
        story: "A warrior whose very existence negates magical energies. His blue skin is inscribed with runes that devour spells and turn them into raw strength.",
        background: "Created by ancient sorcerers as the ultimate anti-magic weapon, he broke free from their control and now hunts all practitioners of the arcane arts.",
        abilities: ["Spell Break", "Magic Drain", "Arcane Immunity"],
        element: "Lightning",
        origin: "The Null Sanctum"
    },
    "010": {
        characterName: "Octo Brain",
        title: "Markus Chen",
        story: "A grotesque octopus beast whose octopus arm flesh weeps with toxic poison. His very presence corrupts the land and spreads pestilence to all living things.",
        background: "Once a healer who sought to cure all diseases, he was consumed by the very plagues he tried to defeat and became their living embodiment.",
        abilities: ["Toxic Cloud", "Disease Touch", "Plague Swarm"],
        element: "Death",
        origin: "The Poisoned Lands"
    },
    "011": {
        characterName: "Zombie Workout Crew",
        title: "Undead Fitness Squad",
        story: "A grotesque gang of bodybuilder zombies who maintain their obsession with gains even after death. Led by their hulking alpha, they prowl gyms and fitness centers, turning workout sessions into nightmarish displays of undead strength.",
        background: "Once dedicated athletes who refused to let death interrupt their training regimen, these zombies have formed an unholy brotherhood. Their decaying muscles still bulge with supernatural power, driven by an eternal hunger for both flesh and iron.",
        abilities: ["Toxic Flex", "Swarm Pump", "Decay Rush"],
        element: "Death",
        origin: "The Abandoned Gym"
    },
    "012": {
        characterName: "Nightmare Lord",
        title: "Master of Fear",
        story: "A purple-skinned demon who feeds on terror and despair. His twisted form and glowing eyes can drive mortals mad with fear at a single glance.",
        background: "Born from the collective nightmares of sleeping minds, he rules over the realm where dreams become twisted into horror.",
        abilities: ["Terror Gaze", "Nightmare Realm", "Fear Drain"],
        element: "Shadow",
        origin: "The Dream Realm"
    },
    "013": {
        characterName: "Flame Lion Sensei",
        title: "Fire Rope Master",
        story: "A fierce lion-human hybrid who masters the ancient art of fire rope combat. In his traditional dojo, he demonstrates that true strength comes from controlling the most dangerous elements.",
        background: "Trained in the secret martial arts of the flame temple, he learned to bind fire itself, becoming master of an art that few dare to attempt.",
        abilities: ["Fire Rope Whip", "Lion's Roar", "Flame Binding"],
        element: "Fire",
        origin: "Fire Temple Dojo"
    },
    "014": {
        characterName: "Astral Knight",
        title: "Starlight Warrior",
        story: "A celestial champion whose blue armor gleams with the light of distant stars. He fights to maintain the cosmic balance between order and chaos.",
        background: "Chosen by the constellation gods to serve as their mortal representative, wielding weapons forged from fallen stars.",
        abilities: ["Starlight Beam", "Cosmic Shield", "Stellar Strike"],
        element: "Light",
        origin: "The Star Realm"
    },
    "015": {
        characterName: "Venom Fang",
        title: "Serpent Assassin",
        story: "A green-scaled warrior with the deadly grace of a viper. His serpentine features and venomous bite make him one of the most feared assassins in any realm.",
        background: "Transformed by ancient snake gods into the perfect predator, combining human intelligence with reptilian lethality.",
        abilities: ["Poison Bite", "Serpent Speed", "Venom Spit"],
        element: "Nature",
        origin: "The Serpent Temple"
    },
    "016": {
        characterName: "Fit Bull",
        title: "Fit Bull",
        story: "A mechanical pink bull whose strong body houses an ancient soul. His muscular form is virtually indestructible and powered by an eternal furnace within.",
        background: "Built by a dying civilization to preserve their greatest warrior's spirit in an imperishable form of living metal.",
        abilities: ["Steel Slam", "Muscle Armor", "Fit Bull"],
        element: "Force",
        origin: "The Iron Foundry"
    },
    "017": {
        characterName: "Chain Breaker",
        title: "Iron Maiden Warrior",
        story: "A fierce warrior who transforms the gym into her battlefield, wielding heavy chains and weights as weapons. Her strength rivals that of ancient titans, and she breaks both iron and enemies with equal ease.",
        background: "Once enslaved and forced to work in underground fighting pits, she forged her chains into tools of liberation. Now free, she uses her prison-born strength and improvised weapons to protect others from oppression.",
        abilities: ["Chain Whip", "Iron Will", "Weight Slam"],
        element: "Metal",
        origin: "The Underground Forge"
    },
    "018": {
        characterName: "The Hulking Lifter",
        title: "Gamma Gym Beast",
        story: "A monstrous green giant whose rage is only matched by his dedication to fitness. Every rep fuels his fury, and every set increases his incredible mass. His workouts are legendary displays of superhuman strength that bend bars and shatter weights.",
        background: "Once a mild-mannered scientist exposed to gamma radiation during a fitness experiment gone wrong, he now channels his transformative anger into the ultimate workout routine. The gym is his sanctuary, where controlled fury becomes controlled power.",
        abilities: ["Rage Press", "Hulk Smash", "Gamma Surge"],
        element: "Radiation",
        origin: "The Irradiated Laboratory"
    },
    "019": {
        characterName: "Cerberus Pack",
        title: "Infernal Hounds",
        story: "Monstrous three-headed hellhounds that patrol the gates between worlds, their howls echoing through ancient stone corridors. These massive beasts serve as eternal guardians, their loyalty unbreakable and their fury unmatched.",
        background: "Born from the fires of the underworld and bound by chains of divine metal, these creatures have watched over forbidden passages for millennia. Their multiple heads allow them to see all threats simultaneously, making them the perfect sentinels of the damned.",
        abilities: ["Triple Bite", "Hellfire Howl", "Guardian's Rage"],
        element: "Fire",
        origin: "The Gates of Hades"
    },
    "020": {
        characterName: "Fallen Angel Enforcer",
        title: "Crimson Seraphim",
        story: "Once a heavenly guardian who fell from grace, this mighty seraphim now serves as an enforcer in the darkest realms. His crimson wings still carry divine power, but his methods have become brutal and unforgiving.",
        background: "Cast out for defying celestial law to protect mortals, he embraced his exile and transformed his righteous fury into something darker. Chains bind his power, but his angelic strength remains formidable, making him a fearsome warrior caught between heaven and hell.",
        abilities: ["Divine Smite", "Fallen Grace", "Wing Storm"],
        element: "Light",
        origin: "The Twilight Realm"
    },
    "021": {
        characterName: "Void Walker",
        title: "Between-Worlds Wanderer",
        story: "A mysterious figure who exists partially in multiple dimensions. His form shifts and wavers as he moves between the spaces that connect all realities.",
        background: "A scholar who delved too deep into forbidden knowledge and became lost between dimensions, gaining power over space itself.",
        abilities: ["Dimensional Rift", "Void Step", "Reality Shift"],
        element: "Shadow",
        origin: "The Void Between Worlds"
    },
    "022": {
        characterName: "Aztec Sky Warrior",
        title: "Feathered Serpent Champion",
        story: "A legendary Aztec warrior blessed with the wings of Quetzalcoatl, soaring above ancient battlefields while wielding chains forged from celestial metal. His aerial dominance and divine strength make him a terror to behold in combat.",
        background: "Chosen by the gods after proving his worth in countless trials, he was granted the sacred feathers of the sky serpent. Now he serves as both protector of his people and executor of divine justice, his chains binding enemies to their fate.",
        abilities: ["Feathered Flight", "Chain Bind", "Divine Descent"],
        element: "Air",
        origin: "The Temple of Winds"
    },
    "023": {
        characterName: "Tentacle Titans",
        title: "Deep Sea Wrestlers",
        story: "Two squid-human warriors locked in eternal combat beneath the waves. Their grappling match has raged for centuries, each testing the other's strength in the ultimate underwater wrestling championship.",
        background: "Born from ancient ocean rivalries, they represent the eternal struggle between order and chaos in the deep sea kingdom.",
        abilities: ["Tentacle Grapple", "Water Wrestling", "Deep Sea Strength"],
        element: "Water",
        origin: "Ocean Floor Arena"
    },
    "024": {
        characterName: "Iron Raven",
        title: "The Weightlifting Wing",
        story: "A massive black bird whose obsession with strength training has made him a legend in the gym. His powerful wings can lift weights that would crush ordinary creatures.",
        background: "Once just another bird, he discovered the iron temple and transformed himself through pure dedication to the iron path.",
        abilities: ["Wing Press", "Talon Grip", "Flight Strength"],
        element: "Air",
        origin: "Iron Temple Gym"
    },
    "025": {
        characterName: "Coral Rex",
        title: "The Squatting Tyrant",
        story: "A magnificent coral-red T-Rex who has mastered the art of powerlifting. His massive legs can squat weights that would make modern strongmen weep in admiration.",
        background: "Evolved in underwater coral reefs where the pressure forged his incredible leg strength, he now dominates the squat rack like he once ruled the prehistoric seas.",
        abilities: ["Prehistoric Squat", "Tyrant's Roar", "Coral Armor"],
        element: "Water",
        origin: "Coral Reef Gym"
    },
    "026": {
        characterName: "Iron Goddess",
        title: "Divine Fitness Queen",
        story: "A powerful goddess who descended from Mount Olympus to revolutionize mortal fitness. Her divine strength allows her to lift weights that would crush lesser beings, while her beauty inspires devotion from all who witness her perfect form.",
        background: "Once content to watch mortals from afar, she grew concerned by their declining physical prowess and decided to personally intervene. Now she operates her own sacred gymnasium, transforming weak mortals into champions through her divine training methods.",
        abilities: ["Divine Press", "Olympian Strength", "Godly Inspiration"],
        element: "Divine",
        origin: "Mount Olympus Gym"
    },
    "027": {
        characterName: "Death's Gym Reaper",
        title: "Skeletal Strongman",
        story: "The Grim Reaper's musclebound brother who traded his scythe for barbells and his hourglass for a stopwatch. This undead bodybuilder proves that death is no excuse to skip leg day, maintaining his gains even in the afterlife.",
        background: "Once a mortal fitness enthusiast who made a deal with Death itself to continue training beyond the grave. Now he serves as the underworld's personal trainer, helping other spirits maintain their supernatural strength while awaiting their final judgment.",
        abilities: ["Death Grip", "Bone Crusher", "Spectral Strength"],
        element: "Death",
        origin: "The Underworld Gym"
    },
    "028": {
        characterName: "Raptor Prime",
        title: "Lizard Lifting Legend",
        story: "A muscular raptor-like creature whose dedication to iron has transformed his reptilian frame into a masterpiece of functional strength. His scaled hide gleams with the sweat of a thousand workouts.",
        background: "Evolved beyond his primitive ancestors through the sacred ritual of lifting, he proves that evolution continues in the weight room.",
        abilities: ["Claw Curl", "Reptile Strength", "Scaled Armor"],
        element: "Earth",
        origin: "Evolution Gym"
    },
    "029": {
        characterName: "Mad Muscles",
        title: "Old School Strongman",
        story: "A grizzled fitness veteran who's been pumping iron since before modern gyms existed. His decades of experience and unwavering dedication have earned him legendary status among younger lifters who seek his wisdom and training methods.",
        background: "Starting his journey in basement gyms and makeshift training spaces, he survived the golden age of bodybuilding and adapted to every fitness trend. Now he serves as a mentor and coach, proving that true strength comes from consistency, discipline, and respect for the iron.",
        abilities: ["Old School Wisdom", "Veteran's Grit", "Iron Discipline"],
        element: "Iron",
        origin: "The Original Gold's Gym"
    },
    "030": {
        characterName: "Shadow Chain Demon",
        title: "Infernal Lifter",
        story: "A demon from the deepest pits of hell who discovered that eternal torment was no match for the burn of a perfect squat. This skeletal fiend has turned his chains of bondage into gym equipment, proving that even the damned can achieve their fitness goals.",
        background: "Banished from the underworld for refusing to torture souls (he preferred to train them instead), he established his own hellish gymnasium. His demonic strength and unbreakable chains make him both an intimidating opponent and an surprisingly effective personal trainer.",
        abilities: ["Hell Squat", "Chain Lightning", "Demonic Endurance"],
        element: "Shadow",
        origin: "The Ninth Circle Gym"
    },
    "031": {
        characterName: "Serpent King Naga",
        title: "Ancient Scale Lord",
        story: "A mighty naga ruler who has slithered from the depths of forgotten temples to claim dominion over the surface world. His massive serpentine form and hypnotic gaze make him a formidable opponent who strikes fear into the hearts of all who face him.",
        background: "Once worshipped as a god by ancient civilizations, he retreated underground when mortals began to forget the old ways. Now he has emerged from his subterranean kingdom, seeking to reclaim his rightful place as lord over both serpent and human alike.",
        abilities: ["Venomous Bite", "Crushing Coils", "Hypnotic Gaze"],
        element: "Poison",
        origin: "The Sunken Temple"
    },
    "032": {
        characterName: "Demon Brothers",
        title: "Infernal Sparring Partners",
        story: "Two demonic siblings locked in eternal combat, their rivalry spanning countless centuries. These muscular fiends have turned their infernal hatred into the ultimate training partnership, pushing each other to new levels of supernatural strength through endless battle.",
        background: "Born from the same pit of hellfire but cursed to never agree on anything, they channel their sibling rivalry into brutal sparring sessions. Their toxic green aura grows stronger with each clash, making them increasingly dangerous opponents who fight as fiercely together as they do against each other.",
        abilities: ["Twin Strike", "Toxic Aura", "Demonic Rage"],
        element: "Poison",
        origin: "The Brimstone Colosseum"
    },
    "033": {
        characterName: "Professor Chaos",
        title: "The Mad Science of Strength",
        story: "A brilliant mad scientist whose wild blonde hair defies gravity as much as his theories defy conventional training wisdom. His bright yellow outfit crackles with experimental energy.",
        background: "Driven to discover the perfect fusion of science and strength, his laboratory experiments have unlocked training methods that seem to break the laws of physics.",
        abilities: ["Science Surge", "Chaos Theory", "Electric Shock"],
        element: "Lightning",
        origin: "Mad Science Laboratory"
    },
    "034": {
        characterName: "Medusa's Champion",
        title: "Serpent Goddess Warrior",
        story: "A powerful warrior blessed by the ancient gorgon Medusa herself, wielding the deadly beauty and serpentine power of her patron goddess. Her emerald skin glows with toxic energy, and her gaze can paralyze enemies with supernatural dread.",
        background: "Once a devoted priestess in Medusa's hidden temple, she was transformed by the goddess's blessing into a living weapon. Now she serves as Medusa's champion in the mortal realm, spreading her mistress's influence while maintaining her own fierce independence and warrior's pride.",
        abilities: ["Petrifying Gaze", "Serpent Strike", "Toxic Beauty"],
        element: "Poison",
        origin: "The Gorgon's Temple"
    },
    "035": {
        characterName: "Taurus Maximus",
        title: "The Unstoppable Bull",
        story: "A massive bull-ox creature with a lion's fierce face, his strength is legendary even among the mightiest beasts. No weight machine can contain his raw power.",
        background: "Born from the union of the strongest land animals, he represents pure, unstoppable force made flesh and muscle.",
        abilities: ["Bull Rush", "Lion's Roar", "Unstoppable Force"],
        element: "Earth",
        origin: "Primal Strength Realm"
    },
    "036": {
        characterName: "Sphinx Guardian",
        title: "Riddle Master Beast",
        story: "An ancient sphinx who has traded riddles for reps, combining the wisdom of ages with the pursuit of physical perfection. His leonine strength and eagle wings make him a formidable opponent who challenges foes both mentally and physically.",
        background: "For millennia, he guarded temple treasures with clever riddles, but grew weary of sedentary scholarly life. Now he seeks to prove that true wisdom includes mastery over one's own body, building muscle while maintaining his legendary intellect and solving the ultimate riddle of peak performance.",
        abilities: ["Wing Buffet", "Riddle Lock", "Sphinx Slam"],
        element: "Wind",
        origin: "The Ancient Library Gymnasium"
    },
    "037": {
        characterName: "The Executioner",
        title: "Masked Mountain",
        summary: "A towering executioner whose massive frame and hooded visage strike terror into all who face him. His incredible bulk and skull-adorned belt mark him as death's own enforcer, wielding strength that can crush bones and spirits alike.",
        background: "Once the royal executioner of a forgotten kingdom, he continued his grim work long after the fall of his masters. Now he wanders between realms, serving as judge, jury, and executioner for those who escape conventional justice, his massive form a testament to years of grim labor.",
        abilities: ["Death Grip", "Final Judgment", "Crushing Blow"],
        element: "Death",
        origin: "The Fallen Kingdom's Dungeons"
    },
    "038": {
        characterName: "Rage Beast",
        title: "Fury Incarnate",
        story: "A monstrous brute whose anger knows no bounds, channeling pure rage into devastating physical power. His hulking frame and demonic features make him a terrifying sight as he destroys everything in his path with uncontrolled fury.",
        background: "Once a mild-mannered gym enthusiast, he was transformed by an experimental serum that amplified both his physical strength and his capacity for anger. Now he struggles to control his monstrous urges while using his incredible power to protect those who cannot protect themselves.",
        abilities: ["Berserker Rage", "Crushing Blow", "Unstoppable Force"],
        element: "Fire",
        origin: "The Chemical Laboratory"
    },
    "039": {
        characterName: "Fallen Titan",
        title: "Broken Angel of Iron",
        story: "A fallen angelic beast whose massive muscles strain against his own divine nature. The broken barbell in his hands symbolizes his rejection of heavenly weakness in favor of earthly strength.",
        background: "Cast out of heaven for choosing the path of iron over ethereal power, he now builds his strength in the ruins of his former glory.",
        abilities: ["Fallen Strike", "Iron Will", "Divine Strength"],
        element: "Shadow",
        origin: "Fallen Heaven Gym"
    },
    "040": {
        characterName: "Titan of the Abyss",
        title: "Chained Colossus",
        story: "A massive titan who broke free from the deepest ocean trenches, his incredible bulk straining against the divine chains that once bound him to the seafloor. His emergence has caused tidal waves and earthquakes as he seeks to reclaim his ancient dominion over the surface world.",
        background: "Imprisoned eons ago by the old gods for challenging their authority, he spent millennia building his strength in the crushing depths of the ocean. Now partially freed, he uses his colossal power to break his remaining bonds while battling both divine forces and mortal champions who seek to return him to his watery prison.",
        abilities: ["Tidal Slam", "Chain Break", "Abyssal Roar"],
        element: "Water",
        origin: "The Mariana Trench"
    },
    "041": {
        characterName: "Frost Beard",
        title: "The Ice Troll Strongman",
        story: "A blue-skinned ice beast with a magnificent white beard, his wizard-like appearance hides incredible physical strength. His massive muscles generate enough heat to melt glaciers.",
        background: "Ancient guardian of the frozen wastes, he learned that true magic comes not from spells, but from the iron discipline of strength training.",
        abilities: ["Ice Blast", "Frozen Strength", "Beard Power"],
        element: "Ice",
        origin: "Frozen Stronghold"
    },
    "042": {
        characterName: "Gremlin Demolition Crew",
        title: "Mischievous Wreckers",
        story: "A chaotic duo of green-scaled gremlins who have turned gym equipment into their personal playground of destruction. These winged troublemakers delight in sabotaging workouts and creating mayhem wherever they nest, their toxic breath corroding metal and melting motivation alike.",
        background: "Originally spawned from a chemical spill in an abandoned fitness factory, these creatures feed on frustration and broken equipment. They've formed an unholy partnership, with the larger gremlin leading demolition efforts while his smaller companion scouts for new targets and escape routes.",
        abilities: ["Toxic Breath", "Equipment Sabotage", "Chaos Swarm"],
        element: "Poison",
        origin: "The Abandoned Gym Factory"
    },
    "043": {
        characterName: "Crimson Bender",
        title: "The Bar Breaking Beast",
        story: "A bright red-skinned warrior whose fierce beard frames a face locked in eternal determination. His signature move involves bending massive steel bars in half with pure rage and strength.",
        background: "Forged in the fires of pure anger, he channels his fury into displays of strength that defy comprehension and break the laws of metallurgy.",
        abilities: ["Bar Bend", "Rage Strength", "Crimson Fire"],
        element: "Fire",
        origin: "Forge of Fury"
    },
    "044": {
        characterName: "Lunar Wolf",
        title: "The Barbell Biting Beast",
        story: "A blue werewolf whose dedication to lifting is matched only by his tendency to bite the barbell during intense sets. Blue light emanates from his form as he channels lunar power into his training.",
        background: "Cursed to transform under the full moon, he discovered that the iron path could harness his bestial strength, making him stronger than any ordinary werewolf.",
        abilities: ["Lunar Bite", "Wolf Strength", "Blue Lightning"],
        element: "Lightning",
        origin: "Moonlit Gym"
    },
    "045": {
        characterName: "Golden Reaper",
        title: "Gilded Death",
        story: "A demonic entity forged from molten gold and bound by chains of divine punishment, this skeletal horror combines the beauty of precious metal with the terror of death incarnate. His golden form gleams with malevolent power as he breaks free from his celestial bonds.",
        background: "Once a greedy mortal who hoarded gold above all else, he was cursed by ancient gods to become one with his obsession. Now his body is living gold, beautiful yet deadly, and he seeks to reclaim the treasures he believes are rightfully his while bound by chains that grow heavier with each act of avarice.",
        abilities: ["Midas Touch", "Chain Lash", "Golden Aura"],
        element: "Metal",
        origin: "The Cursed Vault"
    },
    "046": {
        characterName: "Infernal Dragon Lord",
        title: "Armored Devastator",
        story: "A mighty dragon who has forsaken his natural scales for enchanted armor, transforming himself into the ultimate fusion of draconic power and military might. His massive frame bristles with spikes and protective plating while his wings cast shadows of doom over ancient battlefields.",
        background: "Once ruler of a mountain kingdom, he was betrayed by his own generals and left for dead. Rising from near-death, he forged himself new armor from the bones of his enemies and molten metal from his own breath, becoming more machine than beast in his quest for vengeance against those who wronged him.",
        abilities: ["Flame Breath", "Armored Charge", "Wing Crush"],
        element: "Fire",
        origin: "The Scorched Throne Room"
    },
    "047": {
        characterName: "The Chained Titan",
        title: "Bound Powerhouse",
        story: "A colossal warrior whose incredible strength is barely contained by mystical chains that glow with arcane energy. Every rep he performs threatens to shatter his bonds, and his raw power has become both his greatest asset and his eternal prison.",
        background: "Once a champion gladiator who grew too powerful for any arena to contain, he was bound by sorcerers who feared his limitless potential. Now he uses his imprisonment as the ultimate resistance training, turning his chains into the heaviest weights imaginable while plotting his eventual freedom.",
        abilities: ["Chain Break", "Titan's Roar", "Unstoppable Press"],
        element: "Metal",
        origin: "The Sorcerer's Prison"
    },
    "048": {
        characterName: "Crimson Demon Maw",
        title: "The Devouring Beast",
        story: "A terrifying demonic entity whose massive jaws can consume entire armies in a single bite. This horned nightmare emerges from the deepest pits of hell with an insatiable hunger for destruction and the souls of the living.",
        background: "Born from the collective nightmares of ancient warriors, this creature feeds on fear and flesh alike. Its grotesque form is covered in spikes and chitinous plates, while its mouth opens wide enough to swallow buildings whole. The barbell it clutches serves as both weapon and trophy from its latest gym conquest.",
        abilities: ["Devouring Bite", "Fear Aura", "Spike Barrage"],
        element: "Shadow",
        origin: "The Nightmare Realm"
    },
    "049": {
        characterName: "Green Warrior",
        title: "Nature's Fury Champion",
        story: "A champion of nature's fury, the Green Warrior draws strength from the earth beneath his feet and the trees around him.",
        background: "Once a guardian of an ancient forest, he was blessed by the forest spirits with incredible strength and the ability to commune with nature.",
        abilities: ["Nature's Wrath", "Root Bind", "Leaf Shield"],
        element: "Nature",
        origin: "Ancient Forest"
    },
    "050": {
        characterName: "Lunar Werewolf Alpha",
        title: "Moonlit Beast King",
        story: "A powerful werewolf whose transformation reaches its peak under the full moon's light. His massive lupine form combines primal savagery with supernatural strength, making him a fearsome pack leader who commands respect through both dominance and raw physical power.",
        background: "Once the strongest warrior of his clan, he was cursed during a battle with ancient moon spirits. Rather than seeing his lycanthropy as a burden, he embraced the beast within and used his enhanced abilities to unite scattered werewolf packs under his leadership, becoming an alpha among alphas.",
        abilities: ["Howling Rage", "Pack Leader", "Lunar Strength"],
        element: "Moon",
        origin: "The Howling Peaks"
    },
    "051": {
        characterName: "Goblin Prison Warden",
        title: "Dungeon Keeper",
        story: "A brutish goblin who has turned his prison cell into the ultimate training facility, using his chains and bars as resistance equipment. His years of confinement have transformed him from a common criminal into a muscle-bound enforcer who rules the dungeon through sheer physical dominance.",
        background: "Originally imprisoned for raiding merchant caravans, he discovered that the dungeon's heavy chains and iron bars made perfect workout equipment. Over the years, he's grown so powerful that he's become the unofficial warden, keeping other prisoners in line while plotting his eventual escape with his newfound strength.",
        abilities: ["Chain Whip", "Iron Grip", "Prison Break"],
        element: "Earth",
        origin: "The Maximum Security Dungeon"
    },
    "052": {
        characterName: "Violet Sorcerer",
        title: "Purple Mage",
        story: "A mystical warrior-mage whose purple robes shimmer with arcane energy. Her spells bend reality itself to her indomitable will.",
        background: "A scholar who discovered the forbidden arts of reality manipulation, trading her humanity for ultimate magical power.",
        abilities: ["Reality Warp", "Purple Lightning", "Arcane Shield"],
        element: "Lightning",
        origin: "The Forbidden Library"
    },
    "053": {
        characterName: "Shadow Panther",
        title: "The Winged Dark Predator",
        story: "A muscular black panther with powerful wings, representing the perfect fusion of feline grace and aerial supremacy. His shadow form strikes fear into the hearts of all who face him.",
        background: "Born in the darkest jungles where only the strongest survive, he gained his wings through ancient shadow magic, becoming the apex predator of both land and sky.",
        abilities: ["Shadow Strike", "Wing Slash", "Dark Flight"],
        element: "Shadow",
        origin: "Shadow Jungle"
    },
    "054": {
        characterName: "Crimson Reaper",
        title: "Blood-Soaked Assassin",
        story: "A legendary assassin whose silver hair and crimson robes have become synonymous with death itself. This deadly warrior moves through shadows like flowing blood, his twin blades claiming lives with surgical precision while his cold eyes show no mercy to his targets.",
        background: "Once a noble warrior who witnessed the massacre of his entire clan, he abandoned his code of honor and embraced the path of vengeance. Now he serves as a blade for hire, his reputation so fearsome that merely speaking his name is said to invite death's attention.",
        abilities: ["Shadow Strike", "Blade Dance", "Crimson Mist"],
        element: "Shadow",
        origin: "The Blood-Stained Keep"
    },
    "055": {
        characterName: "Purple Demon Enforcer",
        title: "Violet Nightmare",
        story: "A muscular demon whose purple hide gleams with supernatural power as he wields his staff with deadly precision. This infernal enforcer combines brute strength with martial discipline, making him a feared opponent in both the underworld's fighting pits and the mortal realm above.",
        background: "Once a mortal warrior who made a pact with dark forces to gain ultimate strength, his transformation into a demon granted him incredible power at the cost of his humanity. Now he serves as an enforcer for demonic lords while secretly seeking a way to break his infernal contract.",
        abilities: ["Staff Strike", "Demon Strength", "Infernal Rage"],
        element: "Shadow",
        origin: "The Violet Abyss"
    },
    "056": {
        characterName: "Captain Cosmos",
        title: "Stellar Strongman",
        story: "A cosmic superhero whose incredible strength rivals that of entire solar systems. This blue-suited champion uses his workout sessions to maintain the physical power needed to protect galaxies, with each rep building the muscle required to move planets and lift stars.",
        background: "Empowered by cosmic radiation during a deep space mission, he discovered that his newfound abilities required constant training to control. Now he splits his time between saving civilizations and perfecting his physique, knowing that the universe's safety depends on his ability to stay in peak condition.",
        abilities: ["Stellar Strength", "Cosmic Flight", "Planet Punch"],
        element: "Light",
        origin: "The Fortress of Solitude Gym"
    },
    "057": {
        characterName: "Cobra King Trainer",
        title: "Serpent Rope Master",
        story: "A fearsome reptilian warrior who has mastered the art of rope climbing and functional fitness training. His serpentine agility and incredible grip strength make him unbeatable in climbing competitions, while his venomous fangs serve as a deadly reminder to respect proper gym etiquette.",
        background: "Born from an ancient bloodline of snake-human hybrids, he was cast out from his underground kingdom for refusing to follow traditional serpent ways. Instead, he found purpose in the surface world's fitness culture, using his natural climbing abilities to become the ultimate rope training instructor.",
        abilities: ["Serpent Climb", "Coiling Strike", "Venom Spit"],
        element: "Poison",
        origin: "The Underground Serpent Kingdom"
    },
    "058": {
        characterName: "Maze Guardian",
        title: "Labyrinth Lord",
        story: "A red minotaur who guards the entrance to the most dangerous labyrinth ever created. His massive frame blocks the path to ultimate power.",
        background: "The eternal guardian of a maze that contains the greatest treasures and deadliest traps, testing all who seek to claim ultimate power.",
        abilities: ["Maze Strike", "Horn Charge", "Labyrinth Power"],
        element: "Earth",
        origin: "The Eternal Labyrinth"
    },
    "059": {
        characterName: "Dinosaur Hunter",
        title: "Primal Beast Slayer",
        story: "A legendary warrior from a forgotten age who has dedicated his life to hunting the most dangerous prehistoric predators. His bronze-age weapons and incredible physique make him the ultimate survivor in a world where massive dinosaurs still roam the earth.",
        background: "Raised by a tribe that lived alongside dinosaurs, he learned early that only the strongest could survive in a world of giants. After his village was destroyed by a rampaging T-Rex, he swore an oath to become the apex predator among apex predators, using primitive weapons and raw strength to hunt creatures ten times his size.",
        abilities: ["Primal Roar", "Beast Strike", "Survival Instinct"],
        element: "Earth",
        origin: "The Lost Valley"
    },
    "060": {
        characterName: "Infernus the Skull Lord",
        title: "Death's Fire Champion",
        story: "A demonic warrior wreathed in hellfire and crowned with horns of bone. His skull-adorned armor tells the tale of countless victories, while flames dance around his form like living serpents seeking prey.",
        background: "Forged in the deepest pits of the underworld, he serves as death's own champion, bringing the fires of judgment to those who would challenge the natural order.",
        abilities: ["Hellfire Blast", "Soul Burn", "Death's Embrace"],
        element: "Fire",
        origin: "The Underworld"
    },
    "061": {
        characterName: "Mammoth Berserker",
        title: "Ice Age Champion",
        story: "A colossal warrior from the frozen tundra who has merged with the spirit of an ancient mammoth. His massive tusks and incredible bulk make him an unstoppable force on the battlefield, while his primitive weapons carry the weight of millennia-old hunting traditions.",
        background: "The last survivor of a tribe that worshipped mammoth spirits, he underwent a ritual transformation that fused his soul with that of the great beasts. Now he wanders the frozen wastes, carrying both the strength and the eternal loneliness of the extinct giants he has come to embody.",
        abilities: ["Tusk Charge", "Mammoth Stomp", "Ice Age Fury"],
        element: "Ice",
        origin: "The Frozen Wastes"
    },
    "062":  {
        characterName: "Lunar Sentinel",
        title: "Moon's Dark Guardian",
        story: "A horned knight blessed by the dark moon's power, his silver armor gleams with otherworldly light. His torn purple cloak billows like storm clouds as he stands vigil between the world of light and shadow.",
        background: "Chosen by the lunar eclipse to guard the boundaries between realms, he draws strength from the moon's phases and commands the purple mists of twilight.",
        abilities: ["Lunar Strike", "Shadow Cloak", "Twilight Vision"],
        element: "Shadow",
        origin: "Lunar Eclipse"
    },
    "063": {
        characterName: "Crimson Knight",
        title: "Blood Crusader",
        story: "A red-armored paladin whose holy mission has been corrupted by bloodlust. His sword thirsts for righteous battle but his methods have grown dark.",
        background: "A fallen paladin who lost faith in mercy, believing that only through absolute violence can true justice be achieved.",
        abilities: ["Blood Oath", "Corrupted Light", "Dark Crusade"],
        element: "Fire",
        origin: "The Fallen Cathedral"
    },
    "064": {
        characterName: "Leviathan of the Deep",
        title: "Abyssal Titan",
        story: "A monstrous sea creature of unimaginable size that has risen from the deepest ocean trenches to terrorize the surface world. Its massive tentacles can crush warships like toys, while its gaping maw swallows entire schools of whales in a single bite.",
        background: "Ancient beyond measure, this primordial beast has slumbered in the ocean's darkest depths since before recorded history. Awakened by deep-sea mining operations that disturbed its resting place, it now rises to reclaim the seas from the tiny surface dwellers who dare to pollute its domain.",
        abilities: ["Crushing Tentacles", "Tidal Wave", "Abyssal Roar"],
        element: "Water",
        origin: "The Mariana Abyss"
    },
    "065": {
        characterName: "Storm Emperor",
        title: "Lightning Sovereign",
        story: "A blue monarch whose crown is forged from crystallized lightning. His royal edicts are delivered by thunder and enforced by storm.",
        background: "Born during the greatest electrical storm in history, he learned to rule not just people but the very forces of nature.",
        abilities: ["Imperial Lightning", "Storm Crown", "Thunder Decree"],
        element: "Lightning",
        origin: "The Storm Palace"
    },
    "066": {
        characterName: "Bone Lord Overlord",
        title: "Skeletal Death Knight",
        story: "A terrifying undead warrior whose bleached bones gleam with unholy power beneath spiked armor. This horned death knight commands legions of the undead while wielding clawed gauntlets that can rend both flesh and soul with equal ease.",
        background: "Once a proud paladin who fell to corruption during a desperate battle against demonic forces, his transformation into an undead overlord granted him immense power at the cost of his humanity. Now he serves as a general in the armies of darkness, his very presence draining the life from his enemies.",
        abilities: ["Soul Drain", "Bone Spear", "Undead Command"],
        element: "Death",
        origin: "The Cursed Citadel"
    },
    "067": {
        characterName: "Lucifer's Herald",
        title: "The Golden Fallen",
        story: "An angelic warrior whose golden wings still burn with divine light despite his fall from grace. His muscular form radiates both heavenly power and infernal rebellion, making him feared by both sides of the eternal war.",
        background: "Once among heaven's greatest champions, he chose to walk his own path, becoming a force of liberation that answers to neither heaven nor hell.",
        abilities: ["Divine Lightning", "Rebellion's Fire", "Golden Wings"],
        element: "Lightning",
        origin: "Fallen Heaven"
    },
    "068": {
        characterName: "Conan the Destroyer",
        title: "Barbarian King",
        story: "A legendary barbarian warrior whose incredible strength and primal fury have made him the most feared fighter in all the known lands. His massive sword cleaves through armies while his battle cry strikes terror into the hearts of civilized men who have forgotten the savage power that built their kingdoms.",
        background: "Born in the harsh northern wastes where only the strong survive, he carved his way to power through countless battles and conquered kingdoms. Though he now sits on a throne, his heart remains that of a wandering warrior, and he still seeks the thrill of combat above all the comforts of civilization.",
        abilities: ["Savage Strike", "Berserker Rage", "Intimidating Roar"],
        element: "Fire",
        origin: "The Frozen Northlands"
    },
    "069": {
        characterName: "Primal Archer",
        title: "Beast Hunter",
        story: "A masterful archer whose incredible draw strength and primal instincts make him the ultimate hunter of dangerous beasts. His massive bow requires the strength of ten men to draw, but his arrows can pierce dragon scales and bring down giants with a single shot.",
        background: "Raised by a tribe of monster hunters in the deepest wilderness, he learned to track and kill creatures that terrorize civilized lands. His bow is carved from the heartwood of an ancient world tree, and his arrows are fletched with feathers from legendary birds that soar above the clouds.",
        abilities: ["Power Shot", "Beast Tracking", "Piercing Arrow"],
        element: "Wind",
        origin: "The Untamed Wilderness"
    },
    "070": {
        characterName: "Nordic Mountain Guard",
        title: "Frost Peak Sentinel",
        story: "A stalwart guardian of the frozen peaks who stands watch over ancient mountain passes, his spear and shield ready to defend against any who would threaten the sacred highlands. His horned helm and frost-resistant constitution make him an immovable force against both invaders and the harsh mountain elements.",
        background: "Chosen by his clan to serve as the eternal guardian of their ancestral homeland, he has spent years alone on the mountain peaks, honing his skills and strengthening his resolve. His vigil has made him incredibly resilient, and his knowledge of mountain warfare is unmatched by any lowlander.",
        abilities: ["Spear Thrust", "Shield Wall", "Mountain's Endurance"],
        element: "Ice",
        origin: "The Sacred Mountain Peaks"
    },
    "071": {
        characterName: "Emerald Seraph",
        title: "Heaven's Green Champion",
        story: "A powerful angelic warrior whose form radiates with emerald light and divine strength. His heroic gaze pierces through darkness as he stands ready to defend the innocent with heaven's own power.",
        background: "Blessed with the green light of renewal and growth, he serves as heaven's champion of life and protection, bringing hope where darkness threatens to consume.",
        abilities: ["Life Force", "Emerald Beam", "Divine Protection"],
        element: "Nature",
        origin: "Heaven's Garden"
    },
    "072": {
        characterName: "Horned Demon Warlord",
        title: "Infernal Spear Master",
        story: "A mighty demon warlord whose curved horns channel hellfire and whose spear has pierced the hearts of countless champions. This muscle-bound fiend commands legions of lesser demons while personally leading charges into battle, his presence on the battlefield turning the tide of war through sheer intimidation and brutal skill.",
        background: "Rising through the ranks of hell's army through cunning and strength, he earned his position by defeating seven demon lords in single combat. His ornate spear is forged from meteoric iron and blessed with dark magic, making it capable of wounding even divine beings who dare to challenge his authority.",
        abilities: ["Hellfire Spear", "Demonic Command", "Intimidating Presence"],
        element: "Fire",
        origin: "The Burning Citadel"
    },
    "073": {
        characterName: "Shadow Wolf Assassin",
        title: "Midnight Blade",
        story: "A lycanthropic assassin who has mastered the art of stealth and silent death, his wolf-like features hidden beneath a dark hood while his twin blades thirst for blood. This supernatural killer moves through shadows like smoke, striking down his targets before they even know death has found them.",
        background: "Cursed with lycanthropy during a botched assassination attempt, he initially saw his transformation as a weakness. Over time, he learned to harness his enhanced senses and predatory instincts, becoming deadlier than ever before. His dual nature allows him to hunt his prey with both human cunning and bestial ferocity.",
        abilities: ["Shadow Step", "Twin Strike", "Predator's Hunt"],
        element: "Shadow",
        origin: "The Assassin's Guild"
    },
    "074": {
        characterName: "Moonlight Stalker",
        title: "Werewolf Hunter",
        story: "A cursed werewolf who has dedicated his existence to hunting the very monsters he has become. Under the full moon's glow, his bestial form prowls ancient castles and dark forests, seeking to destroy other lycanthropes who have lost themselves to savage hunger and bloodlust.",
        background: "Bitten by a rogue werewolf while serving as a monster hunter, he initially despaired at his transformation. However, he discovered that his curse granted him the perfect tools to track and eliminate others of his kind. Now he walks a lonely path, using his supernatural abilities to protect innocent lives from creatures like himself.",
        abilities: ["Lunar Howl", "Beast Tracking", "Savage Claws"],
        element: "Moon",
        origin: "The Cursed Castle"
    },
    "075": {
        characterName: "Death's Apprentice",
        title: "Hooded Reaper",
        story: "A mysterious figure who serves as Death's personal apprentice, learning the ancient arts of soul collection and otherworldly combat. His wolf-like features and glowing eyes mark him as something more than mortal, while his enchanted blade can cut through both flesh and spirit with equal ease.",
        background: "Chosen by Death itself after a near-fatal encounter with supernatural forces, he was given a choice: perish or serve as an agent of the afterlife. He chose service, trading his mortality for dark knowledge and the power to walk between worlds, collecting souls and maintaining the balance between life and death.",
        abilities: ["Soul Strike", "Death's Shroud", "Spectral Blade"],
        element: "Death",
        origin: "The Realm of the Dead"
    },
    "076": {
        characterName: "Conan the Conqueror",
        title: "Throne of Steel",
        story: "The ultimate barbarian king who has conquered kingdoms through sheer might and cunning, now ruling from his iron throne with the same brutal efficiency he once used to crush his enemies. His legendary sword has tasted the blood of kings and demons alike, while his massive frame serves as a constant reminder of the savage power that built his empire.",
        background: "After years of wandering as a mercenary and adventurer, he united the fractured barbarian tribes and led them to victory against the civilized nations. Now seated upon his hard-won throne, he rules with an iron fist while never forgetting the warrior's code that brought him to power, his crown earned through conquest rather than birthright.",
        abilities: ["Kingly Command", "Throne Strike", "Emperor's Wrath"],
        element: "Metal",
        origin: "The Conquered Palace"
    },
    "077": {
        characterName: "Valkyrie Warden",
        title: "Divine Guardian",
        story: "A legendary Norse warrior blessed by Odin himself with divine wings and supernatural strength. This heavenly guardian serves as protector of sacred battlefields, his sword glowing with celestial light while his raven-black wings carry him swiftly to wherever heroes need aid in their darkest hour.",
        background: "Chosen from among the greatest mortal warriors to serve in Asgard's halls, he was granted wings and divine power to act as Odin's personal emissary on Midgard. His sacred duty is to guide worthy warriors to glorious deaths in battle while ensuring that cowards and oath-breakers face divine justice for their failures.",
        abilities: ["Divine Flight", "Celestial Blade", "Warrior's Blessing"],
        element: "Light",
        origin: "The Halls of Valhalla"
    },
    "078": {
        characterName: "Mammoth Shaman",
        title: "Tusked Berserker",
        story: "A powerful shaman who has merged his spirit with that of an ancient mammoth, gaining incredible size and strength along with the wisdom of the frozen tundra. His massive tusks and primitive spear make him a formidable warrior, while his connection to ice age spirits grants him mystical powers over the frozen elements.",
        background: "The last surviving member of a tribe that worshipped mammoth spirits, he underwent a dangerous ritual to merge his soul with the great beasts his people revered. The transformation granted him immense physical power but trapped him between the world of men and spirits, making him an eternal guardian of the ancient ways.",
        abilities: ["Tusk Gore", "Ice Stomp", "Mammoth Spirit"],
        element: "Ice",
        origin: "The Primordial Tundra"
    },
    "079": {
        characterName: "Jungle Lord",
        title: "Beast King of the Amazon",
        story: "A powerful warrior who has claimed dominion over the deepest jungle, his blue-skinned form marking him as something beyond mortal man. Accompanied by his loyal jaguar companions, he protects the ancient rainforest from those who would exploit its secrets while commanding respect from both predator and prey.",
        background: "Once a civilized man who ventured too deep into forbidden jungle territories, he was transformed by ancient tribal magic and the spirits of the rainforest itself. Now he serves as the eternal guardian of the green world, his enhanced strength and mystical bond with jungle cats making him the apex protector of his verdant domain.",
        abilities: ["Jungle Prowl", "Beast Command", "Savage Leap"],
        element: "Nature",
        origin: "The Heart of the Amazon"
    },
    "080": {
        characterName: "Lion Gladiator",
        title: "Mane of Gold",
        story: "A noble lion warrior who earned his freedom in the gladiatorial arenas through countless victories, his golden mane flowing like a crown as he wields his ceremonial blade. This beast-man champion combines the tactical mind of a seasoned fighter with the raw power and courage that made lions the kings of beasts.",
        background: "Captured as a cub and forced to fight for the entertainment of crowds, he grew from a frightened young lion into a legendary gladiator whose skill and honor won the respect of even his captors. Now free to choose his own battles, he fights only for causes worthy of his noble heart and leonine pride.",
        abilities: ["Roaring Charge", "Mane Shield", "King's Pride"],
        element: "Fire",
        origin: "The Grand Colosseum"
    },
    "081": {
        characterName: "Orc Warlord",
        title: "Mountain Crusher",
        story: "A massive orc chieftain whose incredible strength and brutal combat skills have united the scattered orc tribes under his iron-fisted rule. His spiked gauntlets can shatter stone and his intimidating presence on the battlefield turns even the bravest warriors into quivering cowards.",
        background: "Rising from humble beginnings as a cave-dwelling grunt, he fought his way through countless tribal wars to claim leadership of the mountain clans. His tactical genius and overwhelming physical power have transformed the orcs from scattered raiders into a formidable army that threatens all civilized lands.",
        abilities: ["Crushing Blow", "War Cry", "Tribal Command"],
        element: "Earth",
        origin: "The Bloodfang Mountains"
    },
    "082": {
        characterName: "Abyssal Titan",
        title: "Primordial Terror",
        story: "A colossal demon from the deepest layers of hell whose very presence warps reality around him. This ancient horror towers above mountains, his massive claws capable of rending the earth itself while his horrific maw devours entire armies. Even the smallest glimpse of his true form drives mortals to madness.",
        background: "Imprisoned in the lowest circles of hell since the dawn of creation, this primordial being predates most gods and demons. His recent awakening has sent shockwaves through both celestial and infernal realms, as his power rivals that of the cosmic forces that originally bound him in chains of starlight and shadow.",
        abilities: ["Reality Rend", "Abyssal Roar", "Titan's Grasp"],
        element: "Shadow",
        origin: "The Primordial Abyss"
    },
    "083": {
        characterName: "Desert Wanderer",
        title: "Mars Walker",
        story: "A lone warrior who traverses the endless red wastes of an alien world, his survival gear and curved blade marking him as one of the few who can endure the harsh Martian landscape. This nomadic fighter has adapted to the thin atmosphere and brutal conditions, becoming a master of desert warfare and planetary survival.",
        background: "Stranded on Mars after a colonial expedition went catastrophically wrong, he learned to survive in the planet's unforgiving environment through sheer determination and adaptation. His years of solitude have honed his combat skills and survival instincts, making him a formidable opponent for the alien creatures and rival survivors who compete for the planet's scarce resources.",
        abilities: ["Desert Strike", "Survival Instinct", "Red Planet Endurance"],
        element: "Fire",
        origin: "The Crimson Wastelands"
    },
    "084": {
        characterName: "Death's Champion",
        title: "Undead Executioner",
        story: "A skeletal warrior who serves as Death's personal executioner in the mortal realm, his massive frame and blood-stained axe marking him as the final judge of those who have escaped their destined demise. This undead champion hunts down souls who have cheated death, ensuring that the natural order is maintained through brutal enforcement.",
        background: "Once a legendary executioner who took pride in his work, he was chosen by Death itself to continue his duties even after his mortal body perished. Now he stalks the twilight realm between life and death, his skeletal form immune to mortal weapons while his enchanted axe can sever the threads that bind souls to the living world.",
        abilities: ["Soul Cleave", "Death's Judgment", "Bone Armor"],
        element: "Death",
        origin: "The Gallows of Eternity"
    },
    "085": {
        characterName: "Symbiote Bond",
        title: "Dual Nature Warrior",
        story: "A powerful fighter whose body has become host to an alien symbiote, creating a deadly partnership between human determination and otherworldly strength. The dark entity grants him incredible power and enhanced abilities, but at the cost of constant internal struggle as two consciousness battle for control.",
        background: "Once a skilled martial artist, his life changed forever when he bonded with an alien parasite during a laboratory accident. The symbiote amplifies his physical capabilities to superhuman levels while providing adaptive armor and weaponry, but their relationship is one of constant negotiation between host and entity, each seeking to impose their will on their shared form.",
        abilities: ["Symbiote Strike", "Adaptive Form", "Dual Mind"],
        element: "Shadow",
        origin: "The Research Facility"
    },
    "086": {
        characterName: "Frost King",
        title: "Winter's Wrath",
        story: "A legendary warrior-king who commands the power of eternal winter, his massive frame and flowing beard marking him as master of the frozen realms. This ancient ruler wields ice magic alongside incredible physical strength, freezing his enemies solid before shattering them with his enchanted blade.",
        background: "Once a mortal king who made a pact with winter spirits to save his dying kingdom from famine, he was transformed into an immortal guardian of the ice realm. His sacrifice granted him dominion over frost and snow, but bound him to eternal vigilance against those who would bring unwanted warmth to his crystalline domain.",
        abilities: ["Frost Strike", "Blizzard Command", "Ice Armor"],
        element: "Ice",
        origin: "The Frozen Citadel"
    },
    "087": {
        characterName: "Leopard Scientist",
        title: "Leopard Professor",
        story: "A brilliant researcher whose wild experiments with leopards have given him control over all cats. His yellow leopard crackles with constant energy and doubles as a body guard.",
        background: "A scientist who pushed the boundaries of cat research too far, becoming a living cat ruler who channels pure big cat energy.",
        abilities: ["Leopard Experiment", "Electric Shock", "Mad Science"],
        element: "Lightning",
        origin: "The Lightning Lab"
    },
    "088": {
        characterName: "Lava Beast King",
        title: "Primal Sovereign",
        story: "A massive fire beast hybrid whose primal strength represents the raw power of untamed nature. His roar can be heard across continents.",
        background: "The result of ancient magical experiments, he combines the strength of the mightiest land animals into one unstoppable force.",
        abilities: ["Primal Roar", "Beast Lava", "Wild Strength"],
        element: "Earth",
        origin: "The Primal Realm"
    },
    "089": {
        characterName: "Fallen Goat Master",
        title: "Dark Goat",
        story: "A massive goat warrior whose fall from grace has only increased his terrible power. His long hair burns with dark ice.",
        background: "Once heaven's mightiest champion, he chose power over righteousness and was cast down, gaining strength from his rebellion.",
        abilities: ["Fallen Strike", "Dark Goat", "Rebel Master"],
        element: "Shadow",
        origin: "The Fallen Goat"
    },
    "090": {
        characterName: "Fire Skull Wizard",
        title: "Skull Sage",
        story: "A Skull master of fire magic whose very presence can melt entire armies. His armour contains the wisdom of a thousand mountains.",
        background: "An ancient mage who mastered the ultimate skull magic, becoming one with fire and skulls gaining immortality through flame.",
        abilities: ["Fire Spell", "Skull Wisdom", "Skull Aura"],
        element: "Fire",
        origin: "The Skull Tower"
    },
    "091": {
        characterName: "Infernus the Skull Fist",
        title: "Death's Fire Champion",
        story: "A demonic warrior wreathed in hellfire and crowned with fist of bone. His skull-adorned armor tells the tale of countless victories, while flames dance around his form like living serpents seeking prey.",
        background: "Forged in the deepest pits of the underworld, he serves as death's own champion, bringing the fires of judgment to those who would challenge the natural order.",
        abilities: ["Hellfire Blast", "Soul Burn", "Death's Embrace"],
        element: "Fire",
        origin: "The Underworld"
    },
    "092": {
        characterName: "Sword Guardian",
        title: "Sword Lord",
        story: "A sword warrior who guards the entrance to the most dangerous desert ever in existence. His massive frame blocks the path to the sword that holds ultimate power.",
        background: "The eternal guardian of a desert that contains the greatest treasures and deadliest traps, testing all who seek to claim ultimate power.",
        abilities: ["Sword Strike", "Horn Charge", "Desert Power"],
        element: "Earth",
        origin: "The Eternal Sword"
    },
    "093": {
        characterName: "Shadow Squid",
        title: "Squid Darkness",
        story: "A Huge Man Squid with powerful tentacles who hunts from the ocean below. His silent underwater flight makes him the perfect aerial assassin.",
        background: "A squid blessed by shadow spirits with tentacles, becoming the ultimate predator of both land and sea.",
        abilities: ["Shadow Flight", "Silent Strike", "Dark Tentacles"],
        element: "Water",
        origin: "The Ocean Floor"
    },
    "094": {
        characterName: "Samsonite the Ocean Lord",
        title: "Death's Ocean Champion",
        story: "An Oceanic warrior wreathed in saltwater and crowned with horns of bone. His skull-adorned armor tells the tale of countless victories, while flames dance around his form like living serpents seeking prey.",
        background: "Forged in the deepest pits of the ocean, he serves as death's own champion, bringing the waters of judgment to those who would challenge the natural order.",
        abilities: ["Oceanwater Blast", "Soul Burn", "Death's Embrace"],
        element: "Water",
        origin: "The OceanFloor"
    },
    "095": {
        characterName: "Snake Samurai",
        title: "Digital Warrior",
        story: "A snake-armored warrior from the digital realm where honor meets technology. His electric chain cuts through both flesh and data streams.",
        background: "A gladiator samurai who entered the digital world to combat cyber-demons, merging ancient bushido with futuristic technology.",
        abilities: ["Data Slash", "Cyber Honor", "Digital Strike"],
        element: "Lightning",
        origin: "The Digital Dojo"
    },
    "096":  {
        characterName: "Forest Sentinel",
        title: "Moon's Dark Guardian",
        story: "A horned Forest knight blessed by the dark forest power, his green armor gleams with otherworldly light. His torn green cloak billows like storm clouds as he stands vigil between the world of light and shadow.",
        background: "Chosen by the forest eclipse to guard the boundaries between realms, he draws strength from the forest shadows and commands the neon green mists of twilight.",
        abilities: ["Lunar Strike", "Shadow Cloak", "Twilight Vision"],
        element: "Shadow",
        origin: "Forest Eclipse"
    },
    "097": {
        characterName: "Crimson Gold Knight",
        title: "Blood Crusader",
        story: "A gold-armored paladin whose holy mission has been corrupted by gold lust. His sword thirsts for righteous battle but his methods have grown dark.",
        background: "A fallen paladin who lost faith in mercy, believing that only through absolute violence can true justice be achieved.",
        abilities: ["Blood Oath", "Corrupted Light", "Dark Crusade"],
        element: "Fire",
        origin: "The Fallen Cathedral"
    },
    "098": {
        characterName: "Tyrannus Rex",
        title: "Primal Beast Master",
        story: "A barbarian champion who commands the respect of ancient predators through raw strength and primal instinct. Standing eye-to-eye with the king of dinosaurs in forgotten swamplands, he proves that true warriors earn dominion through courage, not conquest.",
        background: "Once a simple hunter, he ventured into the lost world where time stands still and earned the allegiance of creatures that ruled the earth before men walked upright.",
        abilities: ["Primal Roar", "Beast Command", "Swamp Mastery"],
        element: "Earth",
        origin: "Lost Swamplands"
    },
    "099": {
        characterName: "The Twin Horned",
        title: "Giant and Guardian",
        story: "Two knights bound by ancient oath - the massive giant and his smaller but equally fierce companion. Together they patrol the seas, their white horned helms striking fear into pirate hearts across the seven seas.",
        background: "Brothers in arms who swore to protect merchant vessels from piracy, their combined strength has never met defeat on the high seas.",
        abilities: ["Giant's Strength", "Perfect Teamwork", "Naval Command"],
        element: "Water",
        origin: "High Seas"
    },
    "100": {
        characterName: "Shadow Tree",
        title: "Forest Justice",
        story: "A caped figure whose sword carries the weight of forest judgment. His shadow-wreathed form appears to deliver justice to those who escape mortal law.",
        background: "A former forester who died carrying out his duties, now returns from the woods to punish those who escape earthly justice.",
        abilities: ["Forest Judgment", "Shadow Tree", "Dark Justice"],
        element: "Death",
        origin: "The Executioner's Block"
    },
    "101": {
        characterName: "Lucifer's Horse",
        title: "The Golden Fallen",
        story: "An angelic horse whose power still burn with divine light despite his fall from grace. His muscular form radiates both heavenly power and infernal rebellion, making him feared by both sides of the eternal war.",
        background: "Once among heaven's greatest champions, he chose to walk his own path, becoming a force of liberation that answers to neither heaven nor hell.",
        abilities: ["Divine Lightning", "Rebellion's Fire", "Golden Wings"],
        element: "Lightning",
        origin: "Fallen Heaven"
    },
    "102": {
        characterName: "Shadow Executioner",
        title: "Dark Justice",
        story: "A zombie beast figure whose axe carries the weight of final judgment. His shadow-wreathed form appears to deliver justice to those who escape mortal law.",
        background: "A former executioner who died carrying out his duties, now returns from death to punish those who escape earthly justice.",
        abilities: ["Final Judgment", "Shadow Axe", "Dark Justice"],
        element: "Death",
        origin: "The Executioner's Block"
    },
    "103": {
        characterName: "Swamp Lords",
        title: "Primordial Bog Rulers",
        story: "Ancient swamp creatures who have ruled the fetid marshlands since before man walked the earth. The smaller gray-green beast leads while the massive orange titan follows, both wielding the poisonous power of their domain.",
        background: "Born from the first swamps when the world was young, they command all the toxic life that thrives in stagnant waters.",
        abilities: ["Toxic Breath", "Swamp Control", "Regeneration"],
        element: "Earth",
        origin: "Primordial Swamp"
    },
    "104": {
        characterName: "Savage Defender",
        title: "Moons Shield",
        story: "A savage wolf beast guardian whose sword can turn aside any attack while his clawed hands command the power of all seven seas.",
        background: "Guardian of an underground kingdom who rose to the surface when pollution threatened to destroy all cave life.",
        abilities: ["Savage Shield", "Claw Fist", "Sword Barrier"],
        element: "Moon",
        origin: "Underground Atlantis"
    },
    "105": {
        characterName: "Desert Wind Emperor",
        title: "Desert Sovereign",
        story: "A gray-armored monarch whose helment flows with eternal wind. His royal edicts are written in wind and his justice burns away all lies.",
        background: "A king who immolated himself to save his people from invasion, emerging from the desert wind as an immortal ruler of wind.",
        abilities: ["Imperial Flame", "Desert Crown", "Wind Justice"],
        element: "Wind",
        origin: "The Phoenix Throne"
    },
    "106": {
        characterName: "Neon Warrior",
        title: "Electric Champion",
        story: "A futuristic fighter whose green neon armor pulses with cybernetic energy. He bridges the gap between ancient combat and modern technology.",
        background: "A warrior from a time where magic and technology merged, wielding both sword and circuit in perfect harmony.",
        abilities: ["Neon Strike", "Cyber Shield", "Electric Pulse"],
        element: "Lightning",
        origin: "Neo-Tokyo"
    },
    "107": {
        characterName: "Spider Swamp Thing",
        title: "Bog Monster",
        story: "A massive spider creature born from the fetid depths of ancient swamplands. His monstrous strength is matched only by his territorial fury.",
        background: "A guardian spirit of the desert swamp who takes physical form when his domain is threatened by outside intrusion.",
        abilities: ["Swamp Slam", "Bog Breath", "Marsh Fury"],
        element: "Nature",
        origin: "The Ancient Swamp"
    },
    "108": {
        characterName: "Ice Hook",
        title: "Ice Marksman",
        story: "A mountain climber whose every shot finds its mark and whose spears carry the finality of death itself. His long beard flows like shadows in the wind.",
        background: "A legendary climber who made a pact with death to never miss his target, becoming an agent of fate's final judgment.",
        abilities: ["Death Shot", "Fatal Hook", "Perfect Aim"],
        element: "Death",
        origin: "The Grim Climber"
    },
    "109": {
        characterName: "Divine Lizard",
        title: "Reptile Radiance",
        story: "A lizard beast being whose form blazes with pure holy energy. His boots have walked the paths of heaven and his hands channel divine power.",
        background: "An archangel who descended to earth during the final battle between good and evil, bringing heaven's light to banish all darkness.",
        abilities: ["Divine Beam", "Holy Aura", "Celestial Power"],
        element: "Light",
        origin: "Heaven's Gate"
    },
    "110": {
        characterName: "Eagle Guardians",
        title: "Eagle Sentinels",
        story: "Eagle knights in royal blue who fights with an eagle as one unified force. Their synchronized attacks and shared consciousness make them nearly unstoppable.",
        background: "Man and bird who underwent a mystical ritual to share one soul between two bodies, gaining perfect coordination in exchange for individual identity.",
        abilities: ["Twin Strike", "Shared Soul", "Blue Power"],
        element: "Lightning",
        origin: "The Twin Temple"
    },
    "111": {
        characterName: "Muscle King",
        title: "Strength Incarnate",
        story: "A massive warrior whose incredible physique represents the pinnacle of mortal strength. His overhead sword strike can cleave mountains in half.",
        background: "A barbarian who achieved legendary status through pure physical prowess, proving that raw strength can overcome any obstacle.",
        abilities: ["Mountain Cleaver", "Ultimate Strength", "Berserker Might"],
        element: "Earth",
        origin: "The Savage Peaks"
    },
    "112": {
        characterName: "Spider Lion",
        title: "Spider Beast Warrior",
        story: "A lion-human-spider hybrid who masters rope techniques in his sacred dojo. His long fingers extend like snakes.",
        background: "A guardian of the spider temple who learned to bind web and lions mane into solid form, creating weapons from pure elemental fury.",
        abilities: ["Spider Whip", "Lion's Web", "Web Mane"],
        element: "Nature",
        origin: "The Spider Dojo"
    },
    "113": {
        characterName: "Lava Champion",
        title: "Nature's Strength",
        story: "A lava warrior who draws power directly from the lava floor. Every volcano strengthens him and every molten rock that falls increases his fury.",
        background: "Chosen by the ancient rock master spirits to defend nature from those who would exploit and destroy it.",
        abilities: ["Root Strength", "Lava Storm", "Fire Fury"],
        element: "Nature",
        origin: "The Heart of the volcano"
    },
    "114": {
        characterName: "Desert Knight Wrestler",
        title: "DKW sword",
        story: "Desert wrestler locked in eternal combat beneath the grains of sand. His wrestling match was created under desert whirlpools that last for centuries.",
        background: "Ancient rivals from the deepest desert trenches who compete in an endless contest of strength that shapes the very desert floor.",
        abilities: ["Wrestler Grapple", "Whirlpool Sand", "Pressure Lock"],
        element: "Sand",
        origin: "The Abyssal Arena"
    },
    "115": {
        characterName: "Ms Iron Tail",
        title: "The Lifting Demon",
        story: "A massive raven whose obsession with strength training has made her legendary among land creatures. Her tail can lift weights that would ground any other animal.",
        background: "A blue demon who discovered abandoned gym equipment and became obsessed with building strength, eventually growing to enormous size.",
        abilities: ["Tail Press", "Iron Lift", "Demon's Pride"],
        element: "Lava",
        origin: "The Land Gym"
    },
    "116": {
        characterName: "Maw of the Marsh",
        title: "Devouring Swamp Beast",
        story: "An orange humanoid swamp creature whose massive mouth can swallow a horse whole. His rows of razor teeth and insatiable hunger make him the apex predator of the wetlands.",
        background: "Evolved in the deepest swamps where only the most vicious survive, he has become living proof that in nature, the hungriest always wins.",
        abilities: ["Devouring Bite", "Swamp Camouflage", "Acidic Spit"],
        element: "Earth",
        origin: "Deep Marshland"
    },
    "117": {
        characterName: "Scale Lifter",
        title: "Reptilian Strongman",
        story: "A lizard-like humanoid whose dedication to strength training has transformed him into a powerhouse. His human form protects him while his fist can grip any weight.",
        background: "A simple humanoid reptile who evolved through exposure to magical strength-enhancing crystals, developing human-like intelligence and incredible power.",
        abilities: ["Scale Defense", "Claw Grip", "Reptile Power"],
        element: "Earth",
        origin: "The Crystal Caves"
    },
    "118": {
        characterName: "Mad Philosopher",
        title: "Mad Professor",
        story: "A brilliant researcher whose wild experiments with sunlight have given him control over lightning itself. His golden armour crackles with constant energy.",
        background: "A scientist who pushed the boundaries of electrical research too far, becoming a living conductor who channels pure lightning.",
        abilities: ["Lightning Experiment", "Electric Shock", "Mad Science"],
        element: "Lightning",
        origin: "The Lightning Lab"
    },
    "119": {
        characterName: "Angel Beast King",
        title: "Angel Primal Sovereign",
        story: "A massive angel beast hybrid whose primal strength represents the raw power of untamed nature. His thunderous wings can be heard across continents.",
        background: "The result of ancient magical experiments, he combines the strength of the mightiest angels and beast into one unstoppable force.",
        abilities: ["Primal Fight", "Angel Beast Charge", "Wild Wind Strength"],
        element: "Earth",
        origin: "The Primal Angelic Realm"
    },
    "120": {
        characterName: "Fallen Angel",
        title: "Dark Warrior",
        story: "A massive beast warrior whose fall from grace has only increased his terrible power. His broken halo burns with dark fire.",
        background: "Once heaven's mightiest champion, he chose power over righteousness and was cast down, gaining strength from his rebellion.",
        abilities: ["Fallen Strike", "Dark Halo", "Rebel Power"],
        element: "Shadow",
        origin: "The Fallen Realm"
    },
    "121": {
        characterName: "Wolf Wizard",
        title: "WW Sage",
        story: "A wolf master of wild magic whose very presence can freeze entire armies with fear. His savage nature holds the wisdom of a thousand winters.",
        background: "An ancient wizard who mastered the ultimate wolf magic, becoming one with winter itself and gaining immortality through primal fear.",
        abilities: ["Wizard Spell", "Wolf Wisdom", "Frozen Fear"],
        element: "Shadow",
        origin: "The Frozen Fear"
    },
    "122": {
        characterName: "Thomas The Ice Troll",
        title: "Ice Troll",
        story: "An ice mountain warrior wreathed in frozen knowledge and crowned with mountain dust. His horned helmet armor tells the tale of countless victories, while ice dances around his form like dead kings seeking peace.",
        background: "Forged in the deepest pits of the ice underworld, he serves as the ice mountains own champion, bringing the cold truth of judgment to those who would challenge the natural order.",
        abilities: ["Arctic Blast", "Soul Burn", "Ice Embrace"],
        element: "Ice",
        origin: "The Arctic Underworld"
    },
    "123": {
        characterName: "Mountain Maze Guardian",
        title: "Tunnel Labyrinth Lord",
        story: "An archer beast of a man who guards the entrance to the most dangerous cave systems ever created. His massive frame blocks the path to ultimate underground cities.",
        background: "The eternal guardian of a tunnel entrance that contains the greatest treasures and deadliest traps, testing all who seek to claim ultimate power and discovery.",
        abilities: ["Tunnel Strike", "Horn Charge", "Cave Power"],
        element: "Earth",
        origin: "The Mountain Maze Labyrinth"
    },
    "124": {
        characterName: "Death's Arrow",
        title: "The Unwavering Marksman",
        story: "A long-haired archer whose deadly gaze never misses its mark. His arrows carry the weight of destiny, and his dramatic presence on the battlefield signals the end for his enemies.",
        background: "Trained in the mystic arts of archery, he learned that true accuracy comes not from the eye, but from the soul's unwavering focus.",
        abilities: ["Perfect Shot", "Death Arrow", "Eagle Eye"],
        element: "Wind",
        origin: "Archer's Monastery"
    },
    "125": {
        characterName: "Shadow Plum Assassin",
        title: "Darkness Incarnate",
        story: "A figure of pure shadow whose form shifts like smoke during storms. His weapons are forged from crystallized darkness and his steps make no sound.",
        background: "A master assassin who made a pact with shadow itself, trading his physical form for the power to strike from any darkness.",
        abilities: ["Shadow Strike", "Smoke Form", "Darkness Cloak"],
        element: "Shadow",
        origin: "The Void Realm"
    },
    "126": {
        characterName: "Polar Samurai",
        title: "Ploar Warrior",
        story: "A blue-armored warrior from the ice digital realm where honor meets ancient technology. His electric weapons cut through both flesh and data streams.",
        background: "A polar samurai who entered the digital world to combat cyber-demons, merging ancient bushido with ancient technology.",
        abilities: ["Data Slash", "Cyber Honor", "Digital Strike"],
        element: "Lightning",
        origin: "The Frozen Digital Dojo"
    },
    "127":  {
        characterName: "Lunar Wolf Sentinel",
        title: "Moon's Dark Guardian",
        story: "A hooded wolf blessed by the dark moon's power, his body armor gleams with otherworldly light. His torn cloak billows like storm clouds as he stands vigil between the world of light and shadow.",
        background: "Chosen by the lunar eclipse to guard the boundaries between realms, he draws strength from the moon's phases and commands the cold blue mists of twilight.",
        abilities: ["Lunar Strike", "Shadow Cloak", "Twilight Vision"],
        element: "Shadow",
        origin: "Lunar Eclipse"
    },
    "128": {
        characterName: "Ice Polar Knight",
        title: "Ice Polar",
        story: "A blue-armored king whose holy mission has been corrupted by frozen tablets. His sword thirsts for righteous battle but his methods have grown cold.",
        background: "A fallen king who lost faith in mercy, believing that only through absolute cold violence can true justice be achieved.",
        abilities: ["Ice Oath", "Corrupted Light", "Dark Crusade"],
        element: "Ice",
        origin: "The Fallen Snow Cathedral"
    },
    "129": {
        characterName: "The Golden One",
        title: "Gold Wing",
        story: "A golden male angel warrior whose very existence threatens reality itself. His attacks don't just destroy enemies—they erase them from existence entirely.",
        background: "A weapon created by cosmic entities to serve as their agent of absolute destruction when entire realities must be unmade.",
        abilities: ["Reality Erase", "Void Strike", "Existence End"],
        element: "Gold",
        origin: "The Void Nexus"
    },
    "130": {
        characterName: "Blue Fire Storm Emperor",
        title: "Lightning Sovereign",
        story: "A blue bull-demon monarch whose crown is forged from crystallized lightning. His royal edicts are delivered by thunder and enforced by storm.",
        background: "Born during the greatest electrical storm in history, he learned to rule not just people but the very forces of nature.",
        abilities: ["Imperial Lightning", "Storm Crown", "Thunder Decree"],
        element: "Lightning",
        origin: "The Storm Palace"
    },
    "131": {
        characterName: "Shadow Executioner",
        title: "Dark Justice",
        story: "A skeleton warrior figure whose sword carries the weight of final judgment. His shadow-wreathed form appears to deliver justice to those who escape mortal law.",
        background: "A former executioner who died carrying out his duties, now returns from death to punish those who escape earthly justice.",
        abilities: ["Final Judgment", "Shadow Sword", "Dark Justice"],
        element: "Death",
        origin: "The Executioner's Block"
    },
    "132": {
        characterName: "Lucifer's Herald",
        title: "The Golden Fallen",
        story: "An angelic warrior whose golden wings still burn with divine light despite his fall from grace. His muscular form radiates both heavenly power and infernal rebellion, making him feared by both sides of the eternal war.",
        background: "Once among heaven's greatest champions, he chose to walk his own path, becoming a force of liberation that answers to neither heaven nor hell.",
        abilities: ["Divine Lightning", "Rebellion's Fire", "Golden Wings"],
        element: "Lightning",
        origin: "Fallen Heaven"
    },
    "133": {
        characterName: "Demon Lord Sovereign",
        title: "Infernal Overlord",
        story: "A supreme demon lord whose massive horns and azure skin mark him as royalty among the infernal hierarchy. This towering fiend commands legions of lesser demons while wielding a cursed staff that can channel the raw power of hell itself, his very presence warping reality around him with malevolent energy.",
        background: "Having clawed his way to the top of hell's brutal political structure through centuries of warfare and cunning, he now rules over multiple demon realms from his throne of obsidian and flame. His incredible physical power is matched only by his strategic mind, making him a threat to both the mortal world and the celestial realms above.",
        abilities: ["Infernal Command", "Soul Burn", "Demonic Aura"],
        element: "Fire",
        origin: "The Ninth Circle Throne"
    },
    "134": {
        characterName: "Alpha Werewolf",
        title: "Moonrage Beast",
        story: "A massive werewolf whose transformation has reached beyond normal lycanthropic limits, becoming a permanent hybrid of man and beast. His incredible muscle mass and savage claws make him the undisputed alpha of his pack, while his tactical intelligence allows him to coordinate devastating pack attacks against his enemies.",
        background: "Infected by an ancient strain of lycanthropy that originated from primordial moon spirits, his transformation became permanent after years of embracing rather than fighting his bestial nature. Now he leads a growing pack of werewolves, using his enhanced strength and predatory instincts to expand his territory while maintaining enough human cunning to outmaneuver those who hunt him.",
        abilities: ["Pack Leader", "Savage Claws", "Moonlight Fury"],
        element: "Moon",
        origin: "The Howling Caverns"
    },
    "135": {
        characterName: "Conan the Eternal",
        title: "Barbarian God-King",
        story: "The ultimate evolution of the legendary barbarian, now ascended to godhood through countless battles and conquests. His divine strength can shatter mountains while his tactical genius has made him ruler of both mortal and immortal realms. This god-king wields weapons forged from the essence of fallen stars.",
        background: "After millennia of warfare and rulership, he transcended mortal limitations through sheer force of will and the worship of countless followers. Now he stands as both warrior and deity, his throne built from the bones of ancient dragons while his crown bears jewels torn from the hearts of dying gods.",
        abilities: ["Divine Wrath", "God-King's Command", "Stellar Blade"],
        element: "Divine",
        origin: "The Celestial Throne Room"
    },
    "136": {
        characterName: "Infernal Seductress",
        title: "Flame Temptress",
        story: "A powerful demon sorceress whose beauty masks incredible magical power and deadly cunning. Her curved horns channel infernal energy while her flaming staff can incinerate enemies or bend their minds to her will. This seductive fiend uses charm and terror in equal measure to achieve her dark objectives.",
        background: "Rising through hell's political hierarchy through a combination of magical prowess and strategic alliances, she now serves as an infernal ambassador to the mortal realm. Her mission is to corrupt powerful mortals and expand demonic influence, using her supernatural charisma to make allies before revealing her true, terrifying nature.",
        abilities: ["Charm Spell", "Hellfire Blast", "Demonic Seduction"],
        element: "Fire",
        origin: "The Infernal Courts"
    },
    "137": {
        characterName: "Valkyrie Commander",
        title: "Golden Wing Warrior",
        story: "A divine warrior maiden chosen by the gods to lead celestial armies into battle against the forces of darkness. Her golden wings shimmer with holy light while her enchanted blade can cut through both physical armor and spiritual defenses. This angelic champion serves as both protector of the innocent and executor of divine justice.",
        background: "Selected from among the most noble mortal warriors after her heroic death in battle, she was transformed into a valkyrie and granted command over a host of celestial soldiers. Her mission is to maintain the balance between good and evil in the mortal realm while preparing worthy souls for the final battle at the end of times.",
        abilities: ["Divine Strike", "Angelic Flight", "Holy Judgment"],
        element: "Light",
        origin: "The Celestial Battlefields"
    },
    "138": {
        characterName: "Troll Ravager",
        title: "Cave Stalker",
        story: "A massive troll warrior whose incredible regenerative abilities and brute strength make him nearly unstoppable in combat. His crude weapons and primal fighting style belie a cunning intelligence that allows him to set deadly ambushes in his mountain domain, crushing unwary travelers with overwhelming force.",
        background: "Driven from his ancestral caves by expanding human settlements, he has become increasingly aggressive and territorial. His thick hide can shrug off most weapons while his natural healing allows him to recover from seemingly fatal wounds, making him a persistent threat that grows more dangerous with each encounter.",
        abilities: ["Regeneration", "Cave Ambush", "Crushing Blow"],
        element: "Earth",
        origin: "The Mountain Caverns"
    },
    "139": {
        characterName: "Conan the Slayer",
        title: "Mountain Peak Warrior",
        story: "A legendary barbarian whose dual-wielding combat style and unmatched ferocity have made him the terror of civilized lands. Standing atop conquered peaks with weapons stained in the blood of his enemies, this savage warrior embodies the raw, untamed power of the northern wastes where only the strongest survive.",
        background: "Forged by years of brutal combat in the harshest environments, he has mastered the art of fighting with two weapons simultaneously while maintaining perfect balance on treacherous terrain. His horned helm and skull-adorned gear serve as warnings to those who would challenge his dominion over the mountain passes he claims as his own.",
        abilities: ["Dual Strike", "Mountain Stance", "Berserker's Fury"],
        element: "Earth",
        origin: "The Savage Peaks"
    },
    "140": {
        characterName: "Divine Light",
        title: "Heaven's Radiance",
        story: "A celestial being whose form blazes with pure holy energy. His boots have walked the paths of heaven and his hands channel divine power.",
        background: "An archangel who descended to earth during the final battle between good and evil, bringing heaven's light to banish all darkness.",
        abilities: ["Divine Beam", "Holy Aura", "Celestial Power"],
        element: "Light",
        origin: "Heaven's Gate"
    },
    "141": {
        characterName: "Conan the Monument",
        title: "Immortalized Champion",
        story: "The ultimate tribute to the legendary barbarian king, this living statue represents his eternal dominance over all who dare challenge his legacy. Standing atop a monument built from the bones of his enemies, this immortal version of the great warrior watches over his conquered lands with unwavering vigilance.",
        background: "After achieving godhood through countless victories and the worship of millions, his legend became so powerful that it manifested as this eternal monument. The statue serves as both shrine and guardian, coming to life whenever his domain faces threats worthy of the original Conan's personal attention.",
        abilities: ["Monument's Wrath", "Eternal Vigil", "Legend's Power"],
        element: "Divine",
        origin: "The Eternal Monument"
    },
    "142": {
        characterName: "Demon Lord Baal",
        title: "Prince of Destruction",
        story: "A towering demon prince whose blue-skinned form radiates pure malevolence and supernatural power. His massive horns channel infernal energy while his barbed tail can crush stone, making him one of hell's most feared generals. This ancient fiend commands legions of lesser demons in his endless war against the forces of light.",
        background: "One of the original fallen angels who rebelled against heaven eons ago, he has spent millennia perfecting the art of corruption and destruction. His immense physical power is matched only by his cunning intellect, allowing him to manipulate mortals and immortals alike into serving his dark agenda of universal domination.",
        abilities: ["Infernal Flames", "Demonic Dominion", "Soul Crush"],
        element: "Fire",
        origin: "The Burning Throne of Hell"
    },
    "143": {
        characterName: "Viking Brotherhood",
        title: "Frost Peak Raiders",
        story: "Two legendary Norse warriors bound by oath and brotherhood, their horned helms and battle-tested axes marking them as elite raiders from the frozen northlands. These shield-brothers fight as one unit, their coordinated attacks and unwavering loyalty making them nearly unstoppable in mountain warfare.",
        background: "Sworn brothers who survived the brutal trials of the ice peaks together, they have raided countless settlements and earned their place in Viking legend. Their matching purple cloaks and identical fighting styles reflect years of training together, while their knowledge of mountain terrain gives them tactical advantages over lowland enemies.",
        abilities: ["Shield Wall", "Brotherhood Strike", "Mountain Charge"],
        element: "Ice",
        origin: "The Frozen Fjords"
    },
    "144": {
        characterName: "Conan the Crimson",
        title: "Blood-Soaked Warlord",
        story: "A battle-hardened version of the legendary barbarian whose red garments are permanently stained with the blood of countless enemies. His dual-wielding mastery and savage combat techniques have made him a terror on ancient battlefields, where his war cry alone can shatter enemy formations and break the will of opposing armies.",
        background: "After years of non-stop warfare across multiple kingdoms, his fighting style has evolved into something more brutal and efficient than ever before. The crimson cloth he wears serves both as battle standard and psychological weapon, reminding all who face him of the rivers of blood he has spilled in his quest for ultimate dominance.",
        abilities: ["Twin Blade Fury", "Crimson Berserker", "War Cry"],
        element: "Fire",
        origin: "The Blood-Soaked Battlefields"
    },
    "145": {
        characterName: "Minotaur Berserker",
        title: "Labyrinth Lord",
        story: "A colossal minotaur warrior whose massive horns and incredible bulk make him the undisputed ruler of ancient maze-like strongholds. His battle-axe can cleave through stone walls while his bovine rage transforms him into an unstoppable force of destruction that tramples everything in his path.",
        background: "Born in the deepest chambers of a forgotten labyrinth, he has spent centuries perfecting his combat skills while guarding the ancient secrets hidden within his maze. His territorial nature and protective instincts make him a fierce opponent for any who dare enter his domain without permission.",
        abilities: ["Gore Charge", "Labyrinth Rage", "Stone Crusher"],
        element: "Earth",
        origin: "The Ancient Labyrinth"
    },
    "146": {
        characterName: "Shadowmoon Assassin",
        title: "Lunar Beast Killer",
        story: "A hooded werewolf assassin who has learned to harness his lycanthropic curse for stealth and murder, his dual sickles gleaming with silver under the full moon's light. This deadly hunter moves through shadows like flowing darkness, using his enhanced senses and supernatural agility to eliminate targets with surgical precision.",
        background: "Cursed with lycanthropy while serving as a royal assassin, he initially struggled to control his transformations. Through years of disciplined training, he learned to maintain his human intelligence while accessing his wolf-like abilities, becoming deadlier than he ever was as a mere mortal killer.",
        abilities: ["Shadow Strike", "Lunar Fury", "Silent Hunt"],
        element: "Moon",
        origin: "The Assassin's Moonlit Temple"
    },
    "147": {
        characterName: "Undead Barbarian",
        title: "Death's Muscle",
        story: "A skeletal warrior whose massive undead frame retains all the strength and fury of his living days, now amplified by supernatural power that knows no fatigue or pain. His bone-crushing grip and relentless attacks make him a terrifying opponent who fights with the determination of the damned and the power of the grave.",
        background: "Once a legendary barbarian who refused to accept death even as disease ravaged his body, his sheer force of will allowed him to rise as an undead champion. Now he wanders the wasteland seeking worthy opponents to test his eternal strength against, his skeletal form a testament to the power of an unbreakable warrior spirit.",
        abilities: ["Bone Crush", "Undead Endurance", "Death Grip"],
        element: "Death",
        origin: "The Bone Graveyard"
    },
    "148": {
        characterName: "Conan the Skull Bearer",
        title: "Death's Champion",
        story: "A darker incarnation of the legendary barbarian who has embraced the symbols of death and conquest, his skull-adorned belt and grim demeanor reflecting years of brutal warfare. This seasoned warrior has seen so much bloodshed that death itself has become his constant companion, making him fearless in the face of any mortal threat.",
        background: "After witnessing the fall of entire civilizations and the deaths of countless comrades, he adopted the skull as his personal symbol - not out of morbid fascination, but as a reminder of mortality's inevitability. His acceptance of death as the ultimate truth has freed him from fear, making him perhaps the most dangerous version of the barbarian king.",
        abilities: ["Death's Embrace", "Skull Crusher", "Fearless Advance"],
        element: "Death",
        origin: "The Fields of Bones"
    },
    "149": {
        characterName: "Demon Lord Malphas",
        title: "Azure Destroyer",
        story: "A towering demon lord whose blue-skinned form radiates pure malevolence and infernal power. His massive horns channel hellfire while his barbed tail can shatter mountains, making him one of the most feared generals in hell's endless army. This ancient fiend delights in corruption and the systematic destruction of all that is pure and good.",
        background: "Rising from the deepest pits of the underworld through centuries of brutal conquest, he has earned his position through a combination of raw power and strategic brilliance. His crimson sash marks him as nobility among demonkind, while his skull-adorned belt serves as a grim reminder of the countless heroes who have fallen before his might.",
        abilities: ["Hellfire Blast", "Demonic Supremacy", "Soul Rend"],
        element: "Fire",
        origin: "The Crimson Throne of Malphas"
    },
    "150": {
        characterName: "Beast King",
        title: "Primal Sovereign",
        story: "A massive savage warrior whose primal strength represents the raw power of untamed nature. His roar can be heard across continents.",
        background: "The result of ancient magical experiments, he combines the strength of the mightiest land animals into one unstoppable force.",
        abilities: ["Primal Roar", "Beast Charge", "Wild Strength"],
        element: "Earth",
        origin: "The Primal Realm"
    }
};

// Helper function to generate names from filenames
function generateCharacterName(filename, folder, position) {
    // For train cards, extract character name from filename
    if (folder === 'train-cards') {
        if (filename.startsWith('train_v')) {
            // Handle train_v22.png style
            const versionNumber = filename.match(/train_v(\d+)/)?.[1];
            return `Training Master ${versionNumber}`;
        } else {
            // Handle train_albert-einstein.png style
            const nameMatch = filename.match(/train_(.+)\.png$/);
            if (nameMatch) {
                return nameMatch[1]
                    .split('-')
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(' ');
            }
        }
    }

    // For build cards
    if (folder === 'build-cards') {
        const buildNumber = filename.match(/build_(\d+)/)?.[1];
        return `Build Specialist ${buildNumber}`;
    }

    // For move cards
    if (folder === 'move-cards') {
        const elementMatch = filename.match(/(earth|fire|forest|water)(\d+)/);
        if (elementMatch) {
            const element = elementMatch[1].charAt(0).toUpperCase() + elementMatch[1].slice(1);
            const number = elementMatch[2];
            return `${element} Master ${number}`;
        }
    }

    // For battle cards (UUID or numbered)
    if (folder === 'battle-cards') {
        if (filename.includes('battle_v')) {
            const vNumber = filename.match(/battle_v(\d+)/)?.[1];
            return `Battle Veteran ${vNumber}`;
        } else {
            // UUID-based battle cards
            return `Battle Champion ${position}`;
        }
    }

    return `Character ${position}`;
}

// Helper function to generate titles based on card type
function generateTitle(filename, folder) {
    if (folder === 'train-cards') return "Elite Training Specialist";
    if (folder === 'build-cards') return "Muscle Building Expert";
    if (folder === 'move-cards') {
        const element = filename.match(/(earth|fire|forest|water)/)?.[1];
        if (element) {
            const elementName = element.charAt(0).toUpperCase() + element.slice(1);
            return `${elementName} Movement Specialist`;
        }
        return "Movement Specialist";
    }
    if (folder === 'battle-cards') return "Combat Training Expert";
    return "Fitness Specialist";
}

// Helper function to get specialties by folder type
function getSpecialtiesByFolder(folder) {
    switch (folder) {
        case 'battle-cards':
            return ["Combat Training", "Mental Toughness", "Strategic Thinking", "Warrior Mindset"];
        case 'build-cards':
            return ["Muscle Building", "Strength Development", "Progressive Overload", "Body Composition"];
        case 'move-cards':
            return ["Movement Patterns", "Mobility Training", "Athletic Performance", "Functional Strength"];
        case 'train-cards':
            return ["Elite Training", "Specialized Coaching", "Performance Optimization", "Advanced Techniques"];
        default:
            return ["General Fitness", "Personal Training", "Health Coaching"];
    }
}

// Helper function to get training style by folder type
function getTrainingStyleByFolder(folder) {
    switch (folder) {
        case 'battle-cards':
            return "Combat Sports & Mental Conditioning";
        case 'build-cards':
            return "Bodybuilding & Strength Training";
        case 'move-cards':
            return "Movement Science & Athletic Performance";
        case 'train-cards':
            return "Elite Athletic Coaching";
        default:
            return "Comprehensive Fitness Training";
    }
}

// Updated helper function to get content for a specific card with fallback
export const getCardContent = (cardNumber) => {
    const paddedNumber = cardNumber.toString().padStart(3, '0');

    // Return existing detailed content if available (cards 1-60)
    if (CARD_CONTENT[paddedNumber]) {
        return CARD_CONTENT[paddedNumber];
    }

    // For cards 61+, generate content based on the card mapping
    const cardData = getCardByPosition(cardNumber);
    if (cardData) {
        const characterName = generateCharacterName(cardData.image, cardData.folder, cardNumber);
        const title = generateTitle(cardData.image, cardData.folder);

        return {
            characterName,
            title,
            story: `${characterName} represents the pinnacle of ${cardData.folder.replace('-', ' ')} mastery. This specialized trainer brings unique expertise and proven methodologies to help you achieve your fitness goals.`,
            background: `Through years of dedicated training and real-world experience, ${characterName} has developed innovative approaches that deliver results for athletes of all levels.`,
            philosophy: "Excellence is achieved through consistent effort and intelligent training",
            specialties: getSpecialtiesByFolder(cardData.folder),
            trainingStyle: getTrainingStyleByFolder(cardData.folder),
            expertise: `${title} Methodology`
        };
    }

    // Ultimate fallback
    return {
        characterName: "Fitness Trainer",
        title: "Fitness Trainer",
        story: "This character's story is being developed. This card represents one of our specialized fitness trainers.",
        background: "Background details for this trainer are coming in future updates.",
        philosophy: "Every journey begins with a single step toward strength",
        specialties: ["Strength Training", "Character Development", "Personal Growth"],
        trainingStyle: "Adaptive & Personalized",
        expertise: "Holistic Fitness Development"
    };
};

// Helper function to check if a card has custom content
export const hasCardContent = (cardNumber) => {
    const paddedNumber = cardNumber.toString().padStart(3, '0');
    return CARD_CONTENT.hasOwnProperty(paddedNumber);
};

// Helper function to check if card has detailed content vs placeholder
export const hasDetailedContent = (cardNumber) => {
    return cardNumber <= 60; // Cards 1-60 have detailed content
};

// Helper function to get content status
export const getContentStatus = (cardNumber) => {
    if (hasDetailedContent(cardNumber)) {
        return 'complete';
    } else {
        return 'generated';
    }
};